import React from "react";

export default function Container({ children, className, style }) {
    return (
        <div className={`flex flex-1 justify-center`} style={style}>
            <div className={`max-w-[1024px] w-full ${className}`}>{children}</div>
        </div>
    );
}
